import { Link } from "react-router-dom";
import BrandMark from "@/components/BrandMark";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-gray-100 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <BrandMark className="h-28 w-auto object-contain -ml-3" />
            <p className="mt-6 text-sm text-gray-600 max-w-sm leading-relaxed">
              Flavor modulation systems and ingredient solutions for the
              food, beverage, and nutraceutical industries.
            </p>
            <p className="mt-6 pm-overline">Better Flavor. Better Formulations.</p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-gray-900 mb-4">
              Company
            </div>
            <ul className="space-y-3 text-sm text-gray-600">
              <li><Link to="/about" data-testid="footer-link-about" className="hover:text-brand">About</Link></li>
              <li><Link to="/applications" data-testid="footer-link-applications" className="hover:text-brand">Applications</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-brand">Contact</Link></li>
              <li><Link to="/contact" data-testid="footer-link-sample" className="hover:text-brand">Request a Sample</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-gray-900 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-gray-600">
              <li>
                <a
                  href="mailto:info@premiermodulations.com"
                  data-testid="footer-email"
                  className="hover:text-brand"
                >
                  info@premiermodulations.com
                </a>
              </li>
              <li data-testid="footer-phone">
                <a href="tel:+16144078981" className="hover:text-brand">
                  (614) 407-8981
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-gray-100 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Premier Modulations. All rights reserved.
          </p>
          <p className="text-xs text-gray-400">
            B2B Ingredient Solutions · For Formulators and R&D Teams
          </p>
        </div>
      </div>
    </footer>
  );
}
